import { Collaborator } from 'interfaces/Collaborator';
import { RepositoryParams, api } from '..';

export type CollaboratorFilters = Partial<Collaborator & RepositoryParams>;

export type TerminateParams = {
  terminationDate: string;
  compensationCents?: number;
  healthPlanCents?: number;
};

export const list = async (params: CollaboratorFilters) => {
  return api.get('/colaboradores', { params });
};

export const create = async (params: Collaborator) => {
  return api.post('/colaboradores', { ...params });
};

export const update = async (params: Collaborator) => {
  return api.patch(`/colaboradores/${params.id}`, { ...params });
};

export const retrieve = async (id: string) => {
  return api.get(`/colaboradores/${id}`);
};

export const remove = async (id: string) => {
  return api.delete(`/colaboradores/${id}`);
};

export const terminate = async (id: string, params: TerminateParams) => {
  return api.patch(`/colaboradores/${id}/desligamento`, { ...params });
};
